import { Box, Table, TopBar } from '@sam/components';
import { TableHeader, TableKey, TableRow } from '@sam/components/src/Table/Table.types';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Right, updateSchambeckUserTableConfig, useData } from 'shared';
import { IconComponent, IconType } from '../../components/icons/IconComponent';
import { useUser } from '../../components/UserContext';
import { convertBikesIntoTableEntries } from '../../utils/bike/Bike.utils';
import { isUserAllowedToDo } from '../../utils/user/User.utils';

const BikeOverview: React.FC = () => {
  const { user, axios, updateContextUser } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [filterValue, setFilterValue] = useState<string>('');
  const [includeDeactivated, toggleIncludeDeactivated] = useState<boolean>(false);

  const { data: bikes } = useData(includeDeactivated ? 'BIKES_ALL' : 'BIKES_ALL_ACTIVE', {
    config: { fallbackData: [] },
  });

  /**
   * Holds tableRows for bikes
   */
  const rows: TableRow[] = useMemo(
    () => convertBikesIntoTableEntries(user.right, bikes, navigate),
    [bikes, includeDeactivated, navigate, user.right],
  );

  return (
    <>
      <TopBar title={t('pages.bikes.overview.headline')} onSearch={setFilterValue}>
        {isUserAllowedToDo(user.right, Right.BIKE_CREATE) && (
          <>
            <IconComponent type={IconType.ADD} onClick={() => navigate('/bikes/create')} />
            <IconComponent
              type={IconType.DISABLED}
              style={{ color: includeDeactivated ? '#bc2e46' : '' }}
              onClick={() => toggleIncludeDeactivated(!includeDeactivated)}
            />
          </>
        )}
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.BIKE_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(axios, user, TableKey.BIKE_OVERVIEW, updatedHeader).then(
              (updatedUser) => updatedUser && updateContextUser(updatedUser),
            );
          }}
          filterValue={filterValue}
          rows={rows}
          header={
            t('pages.bikes.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};

export default BikeOverview;
